import React, { useEffect, useState } from 'react';
import { Navbar } from '../Navbar';
import { Footer } from '../Footer';
import { Link } from 'react-router-dom';
import { LoaderIcon, UsersIcon, AlertCircleIcon, ArrowLeftIcon } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import { getTeacherStudents } from '../../services/studentService';
export const StudentDataCheck = () => {
  const {
    currentUser
  } = useAuth();
  const [students, setStudents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  // Load students from Firestore
  useEffect(() => {
    const loadStudents = async () => {
      if (!currentUser) {
        setLoading(false);
        setError('Please log in to view your students');
        return;
      }
      try {
        setLoading(true);
        setError(null);
        console.log('Fetching students for user:', currentUser.uid);
        const fetchedStudents = await getTeacherStudents(currentUser.uid);
        console.log('Fetched students:', fetchedStudents);
        setStudents(fetchedStudents);
      } catch (err) {
        console.error('Error loading students:', err);
        setError('Failed to load students. Please try refreshing the page.');
      } finally {
        setLoading(false);
      }
    };
    loadStudents();
  }, [currentUser]);
  return <div className="w-full min-h-screen bg-gradient-to-r from-[#0F1626] via-[#1E3A8A] to-[#2C3E50] text-white font-sans" data-id="element-6567">
      <Navbar data-id="element-6568" />
      <main className="pt-20 pb-16" data-id="element-6569">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-6570">
          <div className="flex items-center mb-6" data-id="element-6571">
            <Link to="/teacher-dashboard" className="mr-4 p-2 rounded-full hover:bg-white/10 transition-colors" data-id="element-6572">
              <ArrowLeftIcon className="h-5 w-5" data-id="element-6573" />
            </Link>
            <div data-id="element-6574">
              <h1 className="text-3xl font-serif font-bold text-white" data-id="element-6575">
                Student Data Check
              </h1>
              <p className="text-gray-300" data-id="element-6576">
                Verify your student account information
              </p>
            </div>
          </div>
          {/* Main Content */}
          <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 mb-8" data-id="element-6577">
            <div className="flex items-center mb-6" data-id="element-6578">
              <UsersIcon className="h-6 w-6 mr-3 text-deep-pink" data-id="element-6579" />
              <h2 className="text-xl font-medium text-white" data-id="element-6580">
                Student Account Summary
              </h2>
            </div>
            {/* Loading State */}
            {loading && <div className="flex justify-center items-center py-12" data-id="element-6581">
                <LoaderIcon className="h-8 w-8 text-deep-pink animate-spin" data-id="element-6582" />
                <span className="ml-3 text-white" data-id="element-6583">Loading student data...</span>
              </div>}
            {/* Error State */}
            {error && !loading && <div className="bg-red-900/30 text-red-200 p-4 rounded-xl mb-6" data-id="element-6584">
                <div className="flex items-start" data-id="element-6585">
                  <AlertCircleIcon className="h-5 w-5 mr-2 mt-0.5" data-id="element-6586" />
                  <div data-id="element-6587">
                    <p className="font-medium" data-id="element-6588">Error retrieving student data</p>
                    <p className="mt-1" data-id="element-6589">{error}</p>
                  </div>
                </div>
                <button onClick={() => window.location.reload()} className="mt-3 text-sm text-white bg-red-700/50 hover:bg-red-700 px-3 py-1 rounded-md transition-colors" data-id="element-6590">
                  Try Again
                </button>
              </div>}
            {/* Results */}
            {!loading && !error && <div data-id="element-6591">
                <div className="mb-6 bg-deep-pink/20 rounded-lg p-4" data-id="element-6592">
                  <p className="text-lg font-medium" data-id="element-6593">
                    Total Students:{' '}
                    <span className="text-xl font-bold" data-id="element-6594">{students.length}</span>
                  </p>
                </div>
                {students.length === 0 ? <div className="text-center py-8" data-id="element-6595">
                    <p className="text-gray-300 mb-4" data-id="element-6596">
                      No students found in your account
                    </p>
                    <Link to="/my-students" className="inline-block bg-deep-pink hover:bg-burgundy text-white py-2 px-4 rounded-lg transition-colors" data-id="element-6597">
                      Add Students
                    </Link>
                  </div> : <div data-id="element-6598">
                    <div className="overflow-x-auto" data-id="element-6599">
                      <table className="min-w-full divide-y divide-white/10" data-id="element-6600">
                        <thead data-id="element-6601">
                          <tr data-id="element-6602">
                            <th className="px-4 py-3 text-left text-xs font-medium text-gray-300 uppercase tracking-wider" data-id="element-6603">
                              Name
                            </th>
                            <th className="px-4 py-3 text-left text-xs font-medium text-gray-300 uppercase tracking-wider" data-id="element-6604">
                              Email
                            </th>
                            <th className="px-4 py-3 text-left text-xs font-medium text-gray-300 uppercase tracking-wider" data-id="element-6605">
                              Instrument(s)
                            </th>
                            <th className="px-4 py-3 text-left text-xs font-medium text-gray-300 uppercase tracking-wider" data-id="element-6606">
                              Status
                            </th>
                          </tr>
                        </thead>
                        <tbody className="divide-y divide-white/10" data-id="element-6607">
                          {students.map(student => <tr key={student.id} className="hover:bg-white/5" data-id="element-6608">
                              <td className="px-4 py-3 whitespace-nowrap" data-id="element-6609">
                                {student.name}
                              </td>
                              <td className="px-4 py-3 whitespace-nowrap text-gray-300" data-id="element-6610">
                                {student.email}
                              </td>
                              <td className="px-4 py-3 whitespace-nowrap" data-id="element-6611">
                                {student.instruments.join(', ')}
                              </td>
                              <td className="px-4 py-3 whitespace-nowrap" data-id="element-6612">
                                <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${student.status === 'active' ? 'bg-green-900/30 text-green-200' : student.status === 'pending' ? 'bg-yellow-900/30 text-yellow-200' : student.status === 'trial' ? 'bg-blue-900/30 text-blue-200' : 'bg-gray-800 text-gray-300'}`} data-id="element-6613">
                                  {student.status.charAt(0).toUpperCase() + student.status.slice(1)}
                                </span>
                              </td>
                            </tr>)}
                        </tbody>
                      </table>
                    </div>
                    <div className="mt-6 text-sm text-gray-400" data-id="element-6614">
                      <p data-id="element-6615">
                        This information is retrieved directly from your
                        Firestore database. If you're not seeing expected
                        students, check:
                      </p>
                      <ul className="list-disc list-inside mt-2 space-y-1 ml-2" data-id="element-6616">
                        <li data-id="element-6617">
                          You're logged in with the correct teacher account
                        </li>
                        <li data-id="element-6618">
                          Students have been properly added through the Add
                          Student form
                        </li>
                        <li data-id="element-6619">Your database connection is working correctly</li>
                      </ul>
                    </div>
                  </div>}
              </div>}
          </div>
        </div>
      </main>
      <Footer data-id="element-6620" />
    </div>;
};